/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentCategory } from './ContentCategory';
import {
    ContentCategoryFromJSON,
    ContentCategoryFromJSONTyped,
    ContentCategoryToJSON,
} from './ContentCategory';
import type { ContentInCompanySpaceUpgradeResponseActiveVersion } from './ContentInCompanySpaceUpgradeResponseActiveVersion';
import {
    ContentInCompanySpaceUpgradeResponseActiveVersionFromJSON,
    ContentInCompanySpaceUpgradeResponseActiveVersionFromJSONTyped,
    ContentInCompanySpaceUpgradeResponseActiveVersionToJSON,
} from './ContentInCompanySpaceUpgradeResponseActiveVersion';
import type { ContentInCompanySpaceUpgradeResponseAuthorsInner } from './ContentInCompanySpaceUpgradeResponseAuthorsInner';
import {
    ContentInCompanySpaceUpgradeResponseAuthorsInnerFromJSON,
    ContentInCompanySpaceUpgradeResponseAuthorsInnerFromJSONTyped,
    ContentInCompanySpaceUpgradeResponseAuthorsInnerToJSON,
} from './ContentInCompanySpaceUpgradeResponseAuthorsInner';
import type { ContentInCompanySpaceUpgradeResponseLearningEventsInner } from './ContentInCompanySpaceUpgradeResponseLearningEventsInner';
import {
    ContentInCompanySpaceUpgradeResponseLearningEventsInnerFromJSON,
    ContentInCompanySpaceUpgradeResponseLearningEventsInnerFromJSONTyped,
    ContentInCompanySpaceUpgradeResponseLearningEventsInnerToJSON,
} from './ContentInCompanySpaceUpgradeResponseLearningEventsInner';
import type { ContentInCompanySpaceUpgradeResponseOwningCompanySpace } from './ContentInCompanySpaceUpgradeResponseOwningCompanySpace';
import {
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSON,
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSONTyped,
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceToJSON,
} from './ContentInCompanySpaceUpgradeResponseOwningCompanySpace';
import type { ContentManagerUserGroupDashboardContentResponsePublicOffer } from './ContentManagerUserGroupDashboardContentResponsePublicOffer';
import {
    ContentManagerUserGroupDashboardContentResponsePublicOfferFromJSON,
    ContentManagerUserGroupDashboardContentResponsePublicOfferFromJSONTyped,
    ContentManagerUserGroupDashboardContentResponsePublicOfferToJSON,
} from './ContentManagerUserGroupDashboardContentResponsePublicOffer';
import type { ContentParticipationReassignResponseContentVersion } from './ContentParticipationReassignResponseContentVersion';
import {
    ContentParticipationReassignResponseContentVersionFromJSON,
    ContentParticipationReassignResponseContentVersionFromJSONTyped,
    ContentParticipationReassignResponseContentVersionToJSON,
} from './ContentParticipationReassignResponseContentVersion';

/**
 * Content in company space
 * @export
 * @interface ContentInCompanySpaceShowResponse
 */
export interface ContentInCompanySpaceShowResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    ownership_type: ContentInCompanySpaceShowResponseOwnershipTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    promo_image_url: string;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    external_id: number;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    used_license_count: number;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    total_license_count: number;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    content_type: string;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    offer_type: ContentInCompanySpaceShowResponseOfferTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    time_estimation: number;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    certificates_in_space: number;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    certificates_total: number;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    tests_first_attempt_success_ratio_in_space: number;
    /**
     * 
     * @type {number}
     * @memberof ContentInCompanySpaceShowResponse
     */
    tests_first_attempt_success_ratio_total: number;
    /**
     * 
     * @type {string}
     * @memberof ContentInCompanySpaceShowResponse
     */
    marketplace_url: string;
    /**
     * 
     * @type {ContentParticipationReassignResponseContentVersion}
     * @memberof ContentInCompanySpaceShowResponse
     */
    upgradeable_version?: ContentParticipationReassignResponseContentVersion;
    /**
     * 
     * @type {Array<ContentInCompanySpaceUpgradeResponseAuthorsInner>}
     * @memberof ContentInCompanySpaceShowResponse
     */
    authors?: Array<ContentInCompanySpaceUpgradeResponseAuthorsInner>;
    /**
     * 
     * @type {ContentInCompanySpaceUpgradeResponseOwningCompanySpace}
     * @memberof ContentInCompanySpaceShowResponse
     */
    owning_company_space?: ContentInCompanySpaceUpgradeResponseOwningCompanySpace;
    /**
     * 
     * @type {Array<ContentCategory>}
     * @memberof ContentInCompanySpaceShowResponse
     */
    categories?: Array<ContentCategory>;
    /**
     * 
     * @type {ContentInCompanySpaceUpgradeResponseActiveVersion}
     * @memberof ContentInCompanySpaceShowResponse
     */
    active_version?: ContentInCompanySpaceUpgradeResponseActiveVersion;
    /**
     * 
     * @type {ContentInCompanySpaceUpgradeResponseActiveVersion}
     * @memberof ContentInCompanySpaceShowResponse
     */
    draft_version?: ContentInCompanySpaceUpgradeResponseActiveVersion;
    /**
     * 
     * @type {Array<ContentInCompanySpaceUpgradeResponseLearningEventsInner>}
     * @memberof ContentInCompanySpaceShowResponse
     */
    learning_events?: Array<ContentInCompanySpaceUpgradeResponseLearningEventsInner>;
    /**
     * 
     * @type {Array<ContentManagerUserGroupDashboardContentResponsePublicOffer>}
     * @memberof ContentInCompanySpaceShowResponse
     */
    offers?: Array<ContentManagerUserGroupDashboardContentResponsePublicOffer>;
    /**
     * 
     * @type {Array<ContentParticipationReassignResponseContentVersion>}
     * @memberof ContentInCompanySpaceShowResponse
     */
    content_versions?: Array<ContentParticipationReassignResponseContentVersion>;
}


/**
 * @export
 */
export const ContentInCompanySpaceShowResponseOwnershipTypeEnum = {
    Original: 'original',
    Bought: 'bought'
} as const;
export type ContentInCompanySpaceShowResponseOwnershipTypeEnum = typeof ContentInCompanySpaceShowResponseOwnershipTypeEnum[keyof typeof ContentInCompanySpaceShowResponseOwnershipTypeEnum];

/**
 * @export
 */
export const ContentInCompanySpaceShowResponseOfferTypeEnum = {
    PublicAndPrivate: 'public_and_private',
    Public: 'public',
    Private: 'private',
    None: 'none'
} as const;
export type ContentInCompanySpaceShowResponseOfferTypeEnum = typeof ContentInCompanySpaceShowResponseOfferTypeEnum[keyof typeof ContentInCompanySpaceShowResponseOfferTypeEnum];


/**
 * Check if a given object implements the ContentInCompanySpaceShowResponse interface.
 */
export function instanceOfContentInCompanySpaceShowResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "ownership_type" in value;
    isInstance = isInstance && "promo_image_url" in value;
    isInstance = isInstance && "external_id" in value;
    isInstance = isInstance && "used_license_count" in value;
    isInstance = isInstance && "total_license_count" in value;
    isInstance = isInstance && "content_type" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "offer_type" in value;
    isInstance = isInstance && "time_estimation" in value;
    isInstance = isInstance && "certificates_in_space" in value;
    isInstance = isInstance && "certificates_total" in value;
    isInstance = isInstance && "tests_first_attempt_success_ratio_in_space" in value;
    isInstance = isInstance && "tests_first_attempt_success_ratio_total" in value;
    isInstance = isInstance && "marketplace_url" in value;

    return isInstance;
}

export function ContentInCompanySpaceShowResponseFromJSON(json: any): ContentInCompanySpaceShowResponse {
    return ContentInCompanySpaceShowResponseFromJSONTyped(json, false);
}

export function ContentInCompanySpaceShowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentInCompanySpaceShowResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'ownership_type': json['ownership_type'],
        'promo_image_url': json['promo_image_url'],
        'external_id': json['external_id'],
        'used_license_count': json['used_license_count'],
        'total_license_count': json['total_license_count'],
        'content_type': json['content_type'],
        'language': json['language'],
        'name': json['name'],
        'description': json['description'],
        'offer_type': json['offer_type'],
        'time_estimation': json['time_estimation'],
        'certificates_in_space': json['certificates_in_space'],
        'certificates_total': json['certificates_total'],
        'tests_first_attempt_success_ratio_in_space': json['tests_first_attempt_success_ratio_in_space'],
        'tests_first_attempt_success_ratio_total': json['tests_first_attempt_success_ratio_total'],
        'marketplace_url': json['marketplace_url'],
        'upgradeable_version': !exists(json, 'upgradeable_version') ? undefined : ContentParticipationReassignResponseContentVersionFromJSON(json['upgradeable_version']),
        'authors': !exists(json, 'authors') ? undefined : ((json['authors'] as Array<any>).map(ContentInCompanySpaceUpgradeResponseAuthorsInnerFromJSON)),
        'owning_company_space': !exists(json, 'owning_company_space') ? undefined : ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSON(json['owning_company_space']),
        'categories': !exists(json, 'categories') ? undefined : ((json['categories'] as Array<any>).map(ContentCategoryFromJSON)),
        'active_version': !exists(json, 'active_version') ? undefined : ContentInCompanySpaceUpgradeResponseActiveVersionFromJSON(json['active_version']),
        'draft_version': !exists(json, 'draft_version') ? undefined : ContentInCompanySpaceUpgradeResponseActiveVersionFromJSON(json['draft_version']),
        'learning_events': !exists(json, 'learning_events') ? undefined : ((json['learning_events'] as Array<any>).map(ContentInCompanySpaceUpgradeResponseLearningEventsInnerFromJSON)),
        'offers': !exists(json, 'offers') ? undefined : ((json['offers'] as Array<any>).map(ContentManagerUserGroupDashboardContentResponsePublicOfferFromJSON)),
        'content_versions': !exists(json, 'content_versions') ? undefined : ((json['content_versions'] as Array<any>).map(ContentParticipationReassignResponseContentVersionFromJSON)),
    };
}

export function ContentInCompanySpaceShowResponseToJSON(value?: ContentInCompanySpaceShowResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ownership_type': value.ownership_type,
        'promo_image_url': value.promo_image_url,
        'external_id': value.external_id,
        'used_license_count': value.used_license_count,
        'total_license_count': value.total_license_count,
        'content_type': value.content_type,
        'language': value.language,
        'name': value.name,
        'description': value.description,
        'offer_type': value.offer_type,
        'time_estimation': value.time_estimation,
        'certificates_in_space': value.certificates_in_space,
        'certificates_total': value.certificates_total,
        'tests_first_attempt_success_ratio_in_space': value.tests_first_attempt_success_ratio_in_space,
        'tests_first_attempt_success_ratio_total': value.tests_first_attempt_success_ratio_total,
        'marketplace_url': value.marketplace_url,
        'upgradeable_version': ContentParticipationReassignResponseContentVersionToJSON(value.upgradeable_version),
        'authors': value.authors === undefined ? undefined : ((value.authors as Array<any>).map(ContentInCompanySpaceUpgradeResponseAuthorsInnerToJSON)),
        'owning_company_space': ContentInCompanySpaceUpgradeResponseOwningCompanySpaceToJSON(value.owning_company_space),
        'categories': value.categories === undefined ? undefined : ((value.categories as Array<any>).map(ContentCategoryToJSON)),
        'active_version': ContentInCompanySpaceUpgradeResponseActiveVersionToJSON(value.active_version),
        'draft_version': ContentInCompanySpaceUpgradeResponseActiveVersionToJSON(value.draft_version),
        'learning_events': value.learning_events === undefined ? undefined : ((value.learning_events as Array<any>).map(ContentInCompanySpaceUpgradeResponseLearningEventsInnerToJSON)),
        'offers': value.offers === undefined ? undefined : ((value.offers as Array<any>).map(ContentManagerUserGroupDashboardContentResponsePublicOfferToJSON)),
        'content_versions': value.content_versions === undefined ? undefined : ((value.content_versions as Array<any>).map(ContentParticipationReassignResponseContentVersionToJSON)),
    };
}

